import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response, ResponseContentType} from '@angular/http';
import { saveAs } from 'file-saver/FileSaver';
import 'rxjs/Rx' ;

import { appConfig } from '../app.config';
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class ItemService {
  urlString ='';
  constructor(private http: Http, public translate: TranslateService) {

  }

  getAll(page: number = 1, sort: string = '', summ: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    if(localStorage.getItem('filter_'+this.urlString)) {
      currentfilter = JSON.parse(localStorage.getItem('filter_'+this.urlString));
    }


    let currentsum = JSON.parse(summ);
    if(localStorage.getItem('filtersumm_'+this.urlString)) {
      currentsum = JSON.parse(localStorage.getItem('filtersumm_'+this.urlString));
    }
    console.log(currentsum);
    if(!currentsum) {
      currentsum = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);

    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    for (let key in currentsum) {
      if(currentsum[key]) {
        params.set('sum[' + key + ']', currentsum[key])
      }
    }
    return this.http.get(this.urlString+'?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get(this.urlString+'/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get(this.urlString+'/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put(this.urlString+'/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(item: any) {
    return this.http.post(this.urlString+'', item).map((response: Response) => response.json());
  }

  update(item: any) {
    return this.http.put(this.urlString+'/' + item.id, item).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete(this.urlString+'/' + _id).map((response: Response) => response.json());
  }

  printlist(sort: string = '',columns:any[]=[],modelname:string = '',outtype:string = 'pdf', summ: string = '', email: string = '') {
    let tokenapi = '';
    let lang = 'ar';
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.api_token) {
      tokenapi = currentUser.api_token;
      lang = currentUser.lang;
    }
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    let currentsum = JSON.parse(summ);
    if(!currentsum) {
      currentsum = {};
    }

    const params = new URLSearchParams();
    if(email != "")
      params.set('email', email);
    params.set('sorts', sort);
    params.set('outtype', outtype);
    params.set('lang', lang);
    params.set('modelName', this.translate.instant(modelname));

    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }

    for (let col in columns) {
        params.set('cols[' + columns[col].key + ']', this.translate.instant(columns[col].title));
    }
    for (let key in currentsum) {
      if(currentsum[key]) {
        params.set('sum[' + key + ']', currentsum[key])
      }
    }
    const options = new RequestOptions({responseType: ResponseContentType.Blob });
    if(email != ''){
      return this.http.get(this.urlString+'?token='+ tokenapi +'&' + params.toString()).map((response: Response) => response.json())
    }
    else
      window.open(appConfig.apiUrl + this.urlString+'?token='+ tokenapi +'&' + params.toString())

  }

  printlist2(sort: string = '',columns:any[]=[],modelname:string = '',outtype:string = 'pdf', summ: string = '') {
    let tokenapi = '';
    let lang = 'ar';
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.api_token) {
      tokenapi = currentUser.api_token;
      lang = currentUser.lang;
    }
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }
    let currentsum = JSON.parse(summ);
    if(!currentsum) {
      currentsum = {};
    }

    const params = new URLSearchParams();
    params.set('sorts', sort);
    params.set('outtype', outtype);
    params.set('lang', lang);
    params.set('modelName', this.translate.instant(modelname));

    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }

    for (let col in columns) {
      params.set('cols[' + columns[col].key + ']', this.translate.instant(columns[col].title));
    }
    for (let key in currentsum) {
      if(currentsum[key]) {
        params.set('sum[' + key + ']', currentsum[key])
      }
    }
    const options = new RequestOptions({responseType: ResponseContentType.Blob });
    window.open(appConfig.apiUrl + this.urlString+'/?token='+ tokenapi +'&' + params.toString())

  }
}



// WEBPACK FOOTER //
// ./src/app/services/item.service.ts